import React from 'react';
import classNames from 'classnames';
import TitleTag from '@/components/titletag';
import styles from './index.module.scss';

interface IAmountTagProps {
  title: string;
  amount: string | number;
  className?: string;
}

export default function AmountTag({ title, amount, className }: IAmountTagProps) {
  return (
    <div className={classNames('flex-row-nowrap', 'flex-between-start', styles.tag, className)}>
      <TitleTag style={{ marginBottom: 0 }}>{title}</TitleTag>
      <div className={styles.num}>{amount}</div>
    </div>
  );
}
